import { Component, OnInit, inject } from '@angular/core';
import { PermissionService } from '../../../core/services/permission.service';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ElectionApiService } from '../../../core/services/election-api.service';
import { Election } from '../../../core/interfaces/election';
import { ElectionCardComponent } from "../components/election-card/election-card.component";
import { DatePickerModule } from 'primeng/datepicker';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CampaignApiService } from '../../../core/services/campaign-api.service';

@Component({
  selector: 'app-election-list',
  imports: [CommonModule,
            CardModule,
            ButtonModule,
            ToolbarModule,
            IconField,
            InputIcon,
            InputTextModule,
            SelectModule,
            FormsModule,
            RouterModule,
            ElectionCardComponent,
            DatePickerModule,
            BlockUIModule,
            ProgressSpinnerModule],
  templateUrl: './election-list.component.html',
  styleUrl: './election-list.component.scss'
})
export class ElectionListComponent implements OnInit {

  campaings!: Election[];
  blockedDocument = false;

  name!: undefined | null | string;
  result!: "All";  
  sortBy!: undefined | null | string;
  status!: undefined | null | boolean;
  startDateFrom!: undefined | null | Date;
  startDateTo!: undefined | null | Date;

  statusList = [{"name":"All", "code": undefined},
                {"name":"Inactive", "code": false},
                {"name":"Active", "code": true}]
  sortList = [  {"name":"Sort By", "code": undefined},
                {"name":"Most Recent Election Date", "code": 'mostRecentElectionDate'},
                {"name":"Oldest Election Date", "code": 'oldestElectionDate'},              
                {"name":"Most Recent Start Date", "code": 'mostRecentStartDate'},
                {"name":"Oldest Start Date", "code": 'oldestStartDate'}]
  resultList = [ {"name":"All", "code": "All"},  
                {"name":"No Result Recorded", "code": null},
                {"name":"Won", "code": 'WON'},
                {"name":"Lost", "code": 'LOST'}]

  /** Creating an election needs the ADMIN System Role (spec 004, FR-020). */
  canCreateElection = false;

  constructor(private campaignApiService: CampaignApiService) {
    inject(PermissionService).can$('createElection').subscribe(can => this.canCreateElection = can);
  }

  ngOnInit(): void {
    this.loadCampaigns();
    this.status = true;
    this.result = "All";
  }

  loadCampaigns() {
    this.blockedDocument = true;
    this.campaignApiService.getCampaigns().subscribe({
        next: (data) =>{
          this.campaings = data;
          this.blockedDocument = false;
        } ,
        error: (err) => {
          this.blockedDocument = false;
          console.error('Error fetching campaign list', err);
        }
    })
  }

  get filteredItems() {
    
    if(this.campaings) {
          let filtered =  this.campaings.filter(item =>

            (!this.name ||(item.name && item.name.toLowerCase().includes(this.name.toLowerCase())))
            &&
            (this.status == undefined || item.active === this.status)
            &&
            (this.result == "All" || (item.result == null && this.result == null) || item.result?.result === this.result)
            &&            
            (!this.startDateFrom || (item.startDate &&  this.startDateFrom <= new Date(item.startDate + 'T00:00:00')) )
            &&
            (!this.startDateTo || (item.startDate && new Date(item.startDate + 'T00:00:00') <= this.startDateTo) )
          );

          if(this.sortBy === "mostRecentElectionDate" || !this.sortBy) {
            filtered = filtered.sort((a , b) => new Date(b.endDate!).getTime() - new Date(a.endDate!).getTime()!)
          } else if(this.sortBy === "oldestElectionDate") {
            filtered = filtered.sort((a , b) => new Date(a.endDate!).getTime() - new Date(b.endDate!).getTime()!)
          } else if(this.sortBy === "mostRecentStartDate") {
            filtered = filtered.sort((a , b) => new Date(b.startDate!).getTime() - new Date(a.startDate!).getTime()!)
          } else if(this.sortBy === "oldestStartDate") {
            filtered = filtered.sort((a , b) => new Date(a.startDate!).getTime() - new Date(b.startDate!).getTime()!)
          }


          return filtered;
      }
    return [];
  }


}
